import { LoadingState } from "~/components/screens/StateScreen"

import { useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { LoginPanel } from "~/components/LoginPanel"
import { FullScreen } from "~/components/screens/FullScreen"
import { authClient } from "~/lib/auth-client"
import { api } from "~/trpc/react"

export function LoginPage() {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const { data: session, isPending } = authClient.useSession()
	const domain = api.meta.customDomain.useQuery(undefined, { retry: false })

	const isOAuthAuthorizeRequest =
		searchParams.has("client_id") && searchParams.has("redirect_uri")
	const redirectUri = isOAuthAuthorizeRequest
		? `/api/auth/mcp/authorize?${searchParams.toString()}`
		: (searchParams.get("redirect_uri") ?? "/")

	useEffect(() => {
		if (
			!session ||
			(!isOAuthAuthorizeRequest &&
				(!redirectUri.startsWith("/") || redirectUri.startsWith("//")))
		)
			return
		if (isOAuthAuthorizeRequest) {
			window.location.assign(redirectUri)
			return
		}
		navigate(redirectUri, { replace: true })
	}, [isOAuthAuthorizeRequest, navigate, redirectUri, session])

	if (isPending || domain.isLoading) {
		return <LoadingState scope="page" branded />
	}

	if (
		!isOAuthAuthorizeRequest &&
		(!redirectUri.startsWith("/") || redirectUri.startsWith("//"))
	) {
		return (
			<FullScreen
				title="Invalid Request"
				message="Invalid redirect URL provided."
			/>
		)
	}

	return (
		<FullScreen
			title="Log in to Orbit"
			centerContent={
				<LoginPanel
					callbackURL={redirectUri}
					organizationSlug={domain.data?.slug}
				/>
			}
		/>
	)
}
